import SignIn from '@pages/auth/SignIn'
import React from 'react'

function AuthGuard() {
  return (
   <div className="d-flex justify-content-center align-items-center vh-100 " >
      <SignIn/></div>
  )
}

export default AuthGuard